import { Controller } from "@hotwired/stimulus"

// The builder's Submission details card collapses to one line of chips
// (TASK-267.6) and "Show ▾" expands today's full rows. Client-side only:
// nothing about the expanded state is worth a round trip or persisting.
//
// Targets: `content` (the full rows, rendered `hidden`), `summary` (the
// collapsed chip line, hidden while expanded), `label` ("Show"/"Hide") and
// `chevron`. The `button` carries aria-expanded/aria-controls.
export default class extends Controller {
  static targets = ["content", "summary", "label", "chevron", "button"]

  toggle(event) {
    event.preventDefault()
    const open = this.contentTarget.hidden
    this.contentTarget.hidden = !open
    if (this.hasSummaryTarget) this.summaryTarget.hidden = open
    if (this.hasLabelTarget) this.labelTarget.textContent = open ? "Hide" : "Show"
    if (this.hasChevronTarget) this.chevronTarget.classList.toggle("rotate-180", open)
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", String(open))
  }
}
